<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <a
          :id="id"
          v-test="{ link: id }"
          :href="href"
          :target="target"
          class="wb"
          v-on="on">
        {{ text }}
      </a>
    </template>
    <span class="wb">
      {{ tip }}
    </span>
  </v-tooltip>
</template>

<style scoped>
.wb {
  word-break: break-word !important;
}
</style>

<script>
  export default {
    props: {
      tip: {
        type: String,
        default: ''
      },
      href: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: null
      },
      target: {
        type: String,
        default: '_blank'
      }
    }
  }
</script>
